import Auth from './auth/reducer';
import App from './app/reducer';
import Calendar from './calendar/reducer';
import DynamicChartComponent from './dynamicEchart/reducer';
import ThemeSwitcher from './themeSwitcher/reducer';
import LanguageSwitcher from './languageSwitcher/reducer';

export default {
  Auth,
  App,
  Calendar,
  ThemeSwitcher,
  LanguageSwitcher,
  DynamicChartComponent
};



// WEBPACK FOOTER //
// ./src/redux/reducers.js